module.exports = __webpack_public_path__ + "static/media/waterpolo_icon.793b5354.svg";